const initialState = {
    responseCommentsList: {},
    responseComments: {}
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {
        case "COMMENTS_LIST_RESPONSE":
            newState.responseCommentsList = action.value
            break;
        case "COMMENTS_RESPONSE":
            newState.responseComments = action.value
            break;
        case "UPLOAD_IMAGE_BACKOFFICE_RESPONSE":
            newState.responseUploadImage = action.value
            break;
        default:
            return newState;
    }

    return newState;
};

export default reducer;